import { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Activity } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const ok = await login(username, password);
    if (!ok) {
      setError("아이디 또는 비밀번호가 올바르지 않습니다.");
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "var(--space-3)" }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: "var(--radius-md)",
              background: "var(--accent-soft)",
              border: "1px solid rgba(59,130,246,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Activity size={26} color="var(--accent)" />
          </div>
        </div>

        <h2>KORU Control Tower</h2>
        <p className="login-subtitle">
          멀티에셋 퀀트 트레이딩 & 자산배분 관제 시스템
        </p>

        {error && <div className="login-error">{error}</div>}

        <div style={{ marginBottom: "var(--space-3)" }}>
          <input
            type="text"
            placeholder="관리자 계정 (Username)"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            required
          />
        </div>

        <div style={{ marginBottom: "var(--space-4)" }}>
          <input
            type="password"
            placeholder="보안 비밀번호 (Password)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? "보안 인증 중..." : "관제탑 로그인"}
        </button>
      </form>
    </div>
  );
}
